module.exports = __webpack_public_path__ + "img/thumbs.506111c7.svg";